const AR = {
  "currency-saudi": "ريال سعودي",

  // Buttons Labels Repeated
  "modal-ok-btn": "موافق",
  "modal-close-btn": "إغلاق",

  // Navbar

  "arabic-key": "عربي",
  "english-key": "انكليزي",
  "urdu-key": "اوردو",
  "hindi-key": "هندي",
  "main-tab": "الرئيسية",
  "laundry-owners-tab": "المغاسل",
  "Delivery-representatives-tab": "مندوبي التوصيل",
  "Accountant-account-tab": "المحاسبة",
  "admin-name": "المشرف",
  logout: "تسجيل الخروج",

  // ==========================================================================================================================================
  // LogIn
  "login-form-header": "تسجيل الدخول",
  "login-password-placeholder": "كلمة المرور",
  "login-btn-text": "تسجيل الدخول",
  "login-user-name-placeholder": "اسم المستخدم",
  // ==========================================================================================================================================

  // Copy Rights Start
  "copy-rights-start-1": "هل لديك اي سؤال؟",
  "copy-rights-start-2": "تواصل معنا",
  "copy-rights-start-3": "تطبيق خدمات التنظيف",
  "copy-rights-start-4": "| جميع الحقوق محفوظة",
  "copy-rights-start-5": "تطوير شركة التشفير المعاصر للحلول التقنية",

  // ==========================================================================================================================================
  // Main
  "statistics-main-tab": "إحصاءات عامة",
  "joins-requests-main-tab": "طلبات الانضمام",

  // Statistics
  "daily-done-orders-tab": "الطلبات اليومية المنجزة",
  "payed-money-tab": "المبالغ المدفوعة",
  "most-used-laundry": "المغاسل الأكثر استخداماً للتطبيق",
  "Deliverymen-header": "المندوبين",
  "Laundromats-header": "المغاسل",
  "Number-of-completed-orders": "عدد الطلبات المنجزة",
  "sort-label-statistics":
    "المغاسل بدءاَ من الأكثر إلى الأقل استخداماّ للتطبيق(تبعاً للطلبات المنجزة)",
  "number-of-accepted-orders": "عدد الطلبات المقبولة: ",
  "number-of-done-orders": "عدد الطلبات المنجزة: ",
  "number-of-rejected-orders": "عدد الطلبات المرفوضة: ",

  // Join Requests
  "delivery-request-tab": "طلبات مندوبي التوصيل",
  "Laundry-Owner-request-tab": "طلبات أصحاب المغاسل",
  "accept-request": "قبول",
  "reject-request": "رفض",
  "detail-request-button": "تفاصيل الطلب",
  "delivery-person-name": "اسم المندوب",
  "laundry-name": "اسم المغسلة",
  "date-of-request": "تاريخ الطلب",
  "phone-number": "رقم الهاتف",
  "relative-phone-number": "رقم الهاتف لشخص قريب",
  "relative-relation": "صلة القرابة",
  nationality: "الجنسية",
  "id-or-passport": "الهوية أو جواز السفر",
  address: "مدينة الإقامة",
  city: "المدينة",
  "bulding-number": "رقم البناء",
  "floor-number": "رقم الطابق",
  "vehicle-type": "نوع المركبة",
  "vehicle-color": "لون المركبة",
  "vehicle-num": "رقم المركبة",
  "vehicle-license": "رخص المركبة",

  // ==========================================================================================================================================
  // Laundry Owners
  "date-of-join": "تاريخ الانضمام",
  "laund-details-btn": "تفاصيل المغسلة",
  "all-laundries-header": "جميع المغاسل المنضمة إلينا:",
  "all-laundromat-tap": "جميع المغاسل",
  "offers-free-arrive-request-tap": "طلبات عروض التوصيل المجاني",
  "offers-free-arrive-accepted-tap": "العروض المقبولة",

  // Laundry Modal
  "laundry-services-label": "خدمات المغسلة: ",
  "request-service-button": "طلب خدمة",
  "services-laundry-table-column": "الخدمات المقدمة معها",
  "size-laundry-table-column": "حجم الخدمة",
  "item-type-column": "نوع القطعة",

  // Filter Laundry
  "Search-box-placeholder": "ابحث من خلال الاسم أو رقم الهاتف...",
  "choose-city": "اختر مدينة",
  "date-filter-new-to-old": "من الأحدث إلى الأقدم",
  "date-filter-old-to-new": "من الأقدم إلى الأحدث",

  // ==========================================================================================================================================
  // All Delivery
  "all-delivery-header": "جميع المندوبين المنضمين إلينا:",
  "del-details-btn": "تفاصيل المندوب",

  // ==========================================================================================================================================
  // Earnings
  "receivables-required": "الذمم المطلوبة",
  "commission-due": "العمولة المستحقة",
  "the-outcome": "الحصيلة",
  "outcome-zeroing": "تصفير الحصيلة",
  "info-1": 'زر "الحصيلة الاسبوعية" يتفعل يوم الجمعة فقط.',
  "info-2":
    "العمولة المستحقة للمندوب هي مجموع العمولة التي يستحقها عن كل خدمة قام بتنفيذها.",
  "info-3":
    "الذمم المطلوبة من المندوب هي مجموع الضرائب التي يجب أن يدفعها المندوب للأدمن عن كل خدمة.",
  "info-4":
    "الحصيلة في حال كانت رقم موجب أي يجب أن يدفع المندوب للأدمن ، أما في حال كانت رقم سالب أي يجب أن يدفع الأدمن للمندوب.",
  "info-5":
    'عند تصفية الحسابات بين الأدمن و المندوب على الأدمن أن يقوم بتصفير التحصيل عبر الضغط على زر "تصفير الحساب".',
  "Weekly-Outcomes": "الحصيلة الاسبوعية",

  // ==========================================================================================================================================
  // Fees
  "label-1-fees":
    "قيمة الضريبة التي يجب على المندوب أن يدفعها للأدمن على كل طلب:",
  "label-2-fees": "العمولة التي يستحقها المندوب على كل 1 كم:",

  // ==========================================================================================================================================
  // Accountant
  "commissions-and-taxes-tap": "العمولة و الضريبة",
  "earnings-calculate-tap": "حساب الأرباح",

  // ==========================================================================================================================================
  // Offers Free Arrive
  "offer-det-btn": "تفاصيل العرض",
  "categories-label-offer": "فئات المستخدمين المشمولة بالعرض:",
  "offer-time-label": "مدة العرض:",
  from: "من:",
  to: "إلى:",
  "zeroing-cost": "تصفير",
  cost: "التكلفة",
};

export default AR;
